import { get } from "lodash";
import { Occupier } from "../polymer/Occupier.model";
import { Owner } from "../polymer/Owner.model";
import { HouseholdFormData } from "../classes/ApplicationStep1.class";
import { HoldingOccupier } from "./HoldingOccupier.model";
import { HoldingOwner } from "./HoldingOwner.model";
import { Properties } from "./Properties.model";
import { convertRoleToStructureStatus } from "../../utils/form-helper";
import { MyInfo } from "./MyInfo.model";
import { ApplicationStart } from "../classes/ApplicationStart.class";



export class HoldingFormData
{  
  holding_owners    : HoldingOwner[];
  holding_occupiers : HoldingOccupier[];

  constructor(initial?:any){
    this.holding_owners    = get(initial, 'holding_owners',    []);
    this.holding_occupiers = get(initial, 'holding_occupiers', []);
  }

}


/**
 * @description this class is to assign the existing household class values and to 
 * generate holdingFormData values for owner and occupiers. It will be used when init data are present
 * in stage A step 1 eligibility
 */
export class InitIncomingToHoldingFormData extends HouseholdFormData{
  constructor(initial?: HouseholdFormData){
    super(initial);
  }

  getPersonExistingType(currentOwnersUinfins: string[], currentOccupiersUinfins: string[], additionalRolesUinfins: string[], targetUinfin: string) {
      if(currentOwnersUinfins.includes(targetUinfin)) {
         return "owner";
      } else if(currentOccupiersUinfins.includes(targetUinfin)) {
         return "occupier";
      } else if(additionalRolesUinfins.includes(targetUinfin)) {
        return "additional";
      }

      return "";
  }

  generateHoldingForm(applicationStartFormData: ApplicationStart):HoldingFormData{
  let holding_owners:Owner[] = this.incoming_owners;
  let holding_occupiers:Occupier[] = this.incoming_occupiers;
  const currentOwnersUinfins = this.owners.map(item => item.myinfo.uinfin);
  const currentOccupiersUinfins = this.occupiers.map(item => item.myinfo.uinfin);
  const additionalRolesUinfins = applicationStartFormData?.selected_hdb_property?.additional_roles.map(item => item.uinfin) ?? [];
    return new HoldingFormData({
      holding_owners: holding_owners.map(e=> {
        const existingType = this.getPersonExistingType(currentOwnersUinfins, currentOccupiersUinfins, additionalRolesUinfins, e.myinfo?.uinfin);
        return new HoldingOwner({...e, is_proposed:true, type: existingType.length > 0 ? "existing" : "new", existing_type: existingType, original_uinfin: e.myinfo.uinfin })
      }),
      holding_occupiers: holding_occupiers.map(e=> {
        const existingType = this.getPersonExistingType(currentOwnersUinfins, currentOccupiersUinfins, additionalRolesUinfins, e.myinfo?.uinfin);
        return new HoldingOccupier({...e, is_proposed:true, type: existingType.length > 0 ? "existing" : "new", existing_type: existingType, original_uinfin: e.myinfo.uinfin})
      }),
    })
  }
  generateHoldingFormOwnerOnly(order:string):HoldingFormData{
    let holding_owners:Owner[] = this.incoming_owners;
    return new HoldingFormData({
      holding_owners: holding_owners.filter(e=>e.structure_order === order).map(e=> new HoldingOwner({...e, is_proposed:true, type: this.owners?.findIndex(owner=> owner?.myinfo?.uinfin === e.myinfo?.uinfin ) === -1 ? "new" : "existing", original_uinfin: e.myinfo.uinfin})),
      holding_occupiers: [],
    })
  }
  generateHoldingFormOwnerMainApplicantOnly(mainApplicantId: string, selected_hdb_property?: Properties | undefined):HoldingFormData{
    let holding_owners:Owner[] = this.incoming_owners;
    let current_owners:Owner[] = this.owners;
    let temp_owner:Owner[] = [];
    
    
    let holding_occupiers:Occupier[] = this.incoming_occupiers;
    let current_occupiers:Occupier[] = this.occupiers;
    let temp_occupier:Occupier[] = [];

    const incoming_holding_owner = holding_owners.filter(e=>e.myinfo.uinfin === mainApplicantId).map(e=> new HoldingOwner({...e, is_proposed:true, type: this.owners?.findIndex(owner=> owner?.myinfo?.uinfin === e.myinfo?.uinfin ) === -1 ? "new" : "existing", original_uinfin: e.myinfo.uinfin}));
    const incoming_holding_occupier = holding_occupiers.filter(e=>e.myinfo.uinfin === mainApplicantId).map(e=> new HoldingOccupier({...e, is_proposed:true, type: this.owners?.findIndex(owner=> owner?.myinfo?.uinfin === e.myinfo?.uinfin ) === -1 ? "new" : "existing", original_uinfin: e.myinfo.uinfin}));

    if(incoming_holding_owner.length > 0){
      temp_owner = [...incoming_holding_owner];
    }
    else if(incoming_holding_occupier.length > 0){
      temp_occupier = [...incoming_holding_occupier];
    }
    else{
      const current_holding_owner = current_owners.filter(e=>e.myinfo.uinfin === mainApplicantId).map(e=> new HoldingOwner({...e, is_proposed:true, type: this.owners?.findIndex(owner=> owner?.myinfo?.uinfin === e.myinfo?.uinfin ) === -1 ? "new" : "existing", original_uinfin: e.myinfo.uinfin}));
      const current_holding_occupiers = current_occupiers.filter(e=>e.myinfo.uinfin === mainApplicantId).map(e=> new HoldingOccupier({...e, is_proposed:true, type: this.owners?.findIndex(owner=> owner?.myinfo?.uinfin === e.myinfo?.uinfin ) === -1 ? "new" : "existing", original_uinfin: e.myinfo.uinfin}));
      if(current_holding_owner.length > 0){
        temp_owner = [...current_holding_owner];
      }
      else if(current_holding_occupiers.length > 0){
        temp_occupier = [...current_holding_occupiers];
      }
    }

    /**
     * Note: when temp_owner and temp_occupier will be empty then only check additional role
     */
    if(temp_owner.length === 0 && temp_occupier.length === 0){

      const found_additional_role = selected_hdb_property?.additional_roles?.find(e=>e.uinfin === mainApplicantId);
      if(found_additional_role){
        const structure_status = convertRoleToStructureStatus(found_additional_role.role_name);

        const myinfo = new MyInfo({...found_additional_role});

        const additional_owner = new HoldingOwner({original_uinfin:mainApplicantId, is_proposed:false, type: "additional", structure_status: structure_status, myinfo:myinfo}); 
        temp_owner = temp_owner.concat(additional_owner);
      }
    }

    return new HoldingFormData({
      holding_owners: temp_owner,
      holding_occupiers: temp_occupier,
    })
  }
}